const dashboardDefaultStates = {
	diagram: [
		{
			id: 'GrenadesRank',
			title: 'dashboard:dashboard|diagram|tooltip|grenades|title',
			desc: 'dashboard:dashboard|diagram|tooltip|grenades|desc',
			color: '#75CEF4',
			cardId: 'grenades',
		},
		{
			id: 'AimRank',
			title: 'dashboard:dashboard|diagram|tooltip|aim|title',
			desc: 'dashboard:dashboard|diagram|tooltip|aim|desc',
			color: '#FA6496',
			cardId: 'aim',
		},
		{
			id: 'Rating2',
			title: 'dashboard:dashboard|diagram|tooltip|rating2|title',
			desc: 'dashboard:dashboard|diagram|tooltip|rating2|desc',
			color: '#E8D374',
			cardId: 'rating2',
		},
		{
			id: 'TradedCount',
			title: 'dashboard:dashboard|diagram|tooltip|trades|title',
			desc: 'dashboard:dashboard|diagram|tooltip|trades|desc',
			color: '#93A8BF',
			role: 'Rifler',
			cardId: 'tradedCount',
		},
		{
			id: 'OpenKillsCount',
			title: 'dashboard:dashboard|diagram|tooltip|openkills|title',
			desc: 'dashboard:dashboard|diagram|tooltip|openkills|desc',
			color: '#EF8B53',
			role: 'Sniper',
			cardId: 'openKillsCount',
		},
	],
	progressCards: [
		{
			id: 'KillRating',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|kill|rating|title',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|kill|rating|desc',
			icon: '/new-search/progress/Aim.svg',
			block: 'aim',
			cardId: 'aim',
			withGraphicIcon: false,
		},
		{
			id: 'MedianKillTimeByClass',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|median|kill|time|by|class',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|median|kill|time|by|class|desc',
			icon: '/new-search/progress/Aim.svg',
			block: 'aim',
			cardId: 'aim',
			withGraphicIcon: true,
		},
		{
			id: 'MedianDamageTimeByClass',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|median|damage|time|by|class',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|median|damage|time|by|class|desc',
			icon: '/new-search/progress/Aim.svg',
			block: 'aim',
			cardId: 'aim',
			withGraphicIcon: true,
		},
		{
			id: 'AccuracySpottedByClass',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|accuracy|spotted|by|class',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|accuracy|spotted|by|class|desc',
			icon: '/new-search/progress/Aim.svg',
			block: 'aim',
			cardId: 'aim',
			withGraphicIcon: true,
		},
		{
			id: 'FirstBulletAccuracyByClass',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|first|bullet|accuracy',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|first|bullet|accuracy|desc',
			icon: '/new-search/progress/Aim.svg',
			block: 'aim',
			cardId: 'aim',
			withGraphicIcon: true,
		},
		{
			id: 'HeadshotPercentByClass',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|headshot|percent|by|class',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|headshot|percent|by|class|desc',
			icon: '/new-search/progress/Aim.svg',
			block: 'aim',
			cardId: 'aim',
			withGraphicIcon: true,
		},
		{
			id: 'FlashDurationPerThrowPerEnemy',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|flash|duration|per|throw|per|enemy',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|flash|duration|per|throw|per|enemy|desc',
			icon: '/new-search/progress/Grenades-Flash.svg',
			block: 'grenades',
			cardId: 'grenades',
			withGraphicIcon: true,
		},
		{
			id: 'SmokesPer30Rounds',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|smokes|per|30|rounds',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|smokes|per|30|rounds|desc',
			icon: '/new-search/progress/Grenades-Smoke.svg',
			block: 'grenades',
			cardId: 'grenades',
			withGraphicIcon: true,
		},
		{
			id: 'GrenadeDamagePer30Rounds',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|grenade|damage|per|30|rounds',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|grenade|damage|per|30|rounds|desc',
			icon: '/new-search/progress/Grenades-HE.svg',
			block: 'grenades',
			cardId: 'grenades',
			withGraphicIcon: true,
		},
		{
			id: 'EnemiesDamagedWithHEPer30Rounds',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|enemies|damaged|with|he|per|30|rounds',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|enemies|damaged|with|he|per|30|rounds|desc',
			icon: '/new-search/progress/Grenades-HE.svg',
			block: 'grenades',
			cardId: 'grenades',
			withGraphicIcon: true,
		},
		{
			id: 'Rating2',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|rating|2',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|rating|2|desc',
			icon: '/new-search/progress/Rating.svg',
			block: 'general',
			cardId: 'rating2',
			withGraphicIcon: false,
		},
		{
			id: 'OpenKillsCount',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|open|kills|count',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|open|kills|count|desc',
			icon: '/new-search/progress/FirstKills.svg',
			block: 'general',
			cardId: 'openKillsCount',
			withGraphicIcon: false,
		},
		{
			id: 'TradedCount',
			title: 'search.stats.progress.progress-cards.cards.dashboard|progress|traded|count',
			desc: 'search.stats.progress.progress-cards.cards.dashboard|progress|traded|count|desc',
			icon: '/new-search/progress/TradedCount.svg',
			block: 'general',
			cardId: 'tradedCount',
			withGraphicIcon: false,
		},
	],
	rating: [
		{
			avg: 'MedianKillTimeAvg',
			list: 'MedianKillTimeList',
			// title: 'common:common|practice|median',
			title: 'common:tips|median|kills',
			tooltipContent: 'common:tips|median|kills',
			countUnit: 'Sec',
		},
		{
			avg: 'AverageDamageAvg',
			list: 'AverageDamageList',
			title: 'dashboard:dashboard|card|avg|damage|title',
			tooltipContent: 'common:tips|avg|damage|list',
			countUnit: '',
		},
		{
			avg: 'RifleAccuracySpottedAvg',
			list: 'RifleAccuracySpottedList',
			title: 'dashboard:dashboard|card|enemy|spotted|title',
			tooltipContent: 'common:tips|rifle|accuracy|list',
			countUnit: '%',
		},
		{
			avg: 'SniperRifleAccuracyAvg',
			list: 'SniperRifleAccuracyList',
			title: 'dashboard:dashboard|card|sniper|accuracy|title',
			tooltipContent: 'common:tips|sniper|accuracy|list',
			countUnit: '%',
		},
	],
	ratings: [
		{
			order: 1,
			id: 'Rating2',
			title: 'dashboard:dashboard|rating|card|rating2|title',
			tooltipContent: 'dashboard:dashboard|rating|card|rating|2|tip',
			compare: 'min',
			playersAverage: '',
			unit: '',
		},
		{
			order: 2,
			id: 'KAST',
			title: 'dashboard:dashboard|rating|card|kast|title',
			tooltipContent: 'dashboard:dashboard|rating|card|kast|tip',
			compare: 'max',
			playersAverage: '',
			unit: '%',
		},
		{
			order: 3,
			id: 'AverageDamagePerRound',
			title: 'dashboard:dashboard|rating|card|adr|title',
			tooltipContent: 'dashboard:dashboard|rating|card|adr|tip',
			compare: 'min',
			playersAverage: '',
			unit: '',
		},
		{
			order: 4,
			id: 'KillRating',
			title: 'dashboard:dashboard|rating|card|kill|rating|title',
			tooltipContent: 'dashboard:dashboard|rating|card|kill|rating|tip',
			compare: 'max',
			playersAverage: '',
			unit: '',
		},
	],
	aimRatings: [
		{
			order: 1,
			contentType: 'rank',
			id: 'AimRank',
			rankId: 'AimRank',
			title: 'dashboard:dashboard|metrics|aim|tab|ratings|aim|rating',
			description: {
				Sniper: 'dashboard:dashboard|aim|rating',
				Rifler: 'dashboard:dashboard|aim|rating',
			},
			rangeTooltipContent: {
				title: 'dashboard:dashboard|aim|tooltip|title',
				content: 'dashboard:dashboard|aim|tooltip|content',
			},
			unit: 'common:common|sec',
			borderColor: '#846194',
			backgroundColor: 'rgb(132, 97, 148, 0.1)',
			analyticsEventName: 'AimRank',
		},
		{
			order: 2,
			id: 'MedianKillTimeByClass',
			contentType: 'simple',
			rankId: 'MedianKillTimeByClass',
			title: 'dashboard:dashboard|metrics|aim|tab|ratings|kill|time',
			description: {
				Sniper: 'dashboard:dashboard|aim|sniper|kill|time',
				Rifler: 'dashboard:dashboard|aim|rifler|kill|time',
			},
			unit: 'common:common|sec',
			borderColor: '#846194',
			backgroundColor: 'rgb(132, 97, 148, 0.1)',
			analyticsEventName: 'MedianKillTime',
		},
		{
			order: 3,
			id: 'AccuracySpottedByClass',
			contentType: 'simple',
			rankId: 'AccuracySpottedByClass',
			title: 'dashboard:dashboard|metrics|aim|tab|ratings|accuracy',
			description: {
				Sniper: 'dashboard:dashboard|aim|sniper|accuracy',
				Rifler: 'dashboard:dashboard|aim|rifler|accuracy',
			},
			unit: '%',
			borderColor: '#846194',
			backgroundColor: 'rgb(132, 97, 148, 0.1)',
			analyticsEventName: 'AccuracySpotted',
		},
		{
			order: 4,
			id: 'FirstBulletAccuracyByClass',
			contentType: 'simple',
			rankId: 'FirstBulletAccuracyByClass',
			title: 'dashboard:dashboard|metrics|aim|tab|ratings|first|bullet',
			description: {
				Sniper: 'dashboard:dashboard|aim|sniper|first|bullet|accuracy',
				Rifler: 'dashboard:dashboard|aim|rifler|first|bullet|accuracy',
			},
			unit: '%',
			borderColor: '#846194',
			backgroundColor: 'rgb(132, 97, 148, 0.1)',
			analyticsEventName: 'FirstBulletAccuracy',
		},
		{
			order: 5,
			id: 'HeadshotPercentByClass',
			contentType: 'simple',
			rankId: 'HeadshotPercentByClass',
			title: 'dashboard:dashboard|metrics|aim|tab|ratings|headshot|percent',
			description: {
				Rifler: 'dashboard:dashboard|aim|rifler|headshot|percent',
			},
			unit: '%',
			borderColor: '#846194',
			backgroundColor: 'rgb(132, 97, 148, 0.1)',
			analyticsEventName: 'HeadshotPercent',
		},
		{
			order: 6,
			id: 'MedianDamageTimeByClass',
			contentType: 'simple',
			rankId: 'MedianDamageTimeByClass',
			title: 'dashboard:dashboard|metrics|aim|tab|ratings|mdt',
			description: {
				Sniper: 'dashboard:dashboard|aim|mdt|description',
				Rifler: 'dashboard:dashboard|aim|mdt|description',
			},
			unit: 'common:common|sec',
			borderColor: '#846194',
			backgroundColor: 'rgb(132, 97, 148, 0.1)',
			analyticsEventName: 'MedianDamageTime',
		},
	],
	utilityRatings: [
		{
			order: 1,
			id: 'GrenadesRank',
			contentType: 'rank',
			rankId: 'GrenadesRank',
			title: 'dashboard:dashboard|metrics|aim|tab|ratings|grenades|rating',
			description: {
				Sniper: 'dashboard:dashboard|grenades|rating',
				Rifler: 'dashboard:dashboard|grenades|rating',
			},
			unit: '',
			borderColor: '#846194',
			backgroundColor: 'rgb(132, 97, 148, 0.1)',
			analyticsEventName: 'GrenadesRank',
		},
		{
			order: 2,
			id: 'SmokesPer30Rounds',
			contentType: 'simple',
			rankId: 'SmokesPer30Rounds',
			title: 'dashboard:dashboard|metrics|utility|tab|ratings|smokes|per|round',
			description: {
				Sniper: 'dashboard:dashboard|grenades|smokes|per|round',
				Rifler: 'dashboard:dashboard|grenades|smokes|per|round',
			},
			unit: '',
			borderColor: '#846194',
			backgroundColor: 'rgb(132, 97, 148, 0.1)',
			analyticsEventName: 'SmokesPerMatch',
		},
		{
			order: 3,
			id: 'FlashDurationPerThrowPerEnemy',
			contentType: 'simple',
			rankId: 'FlashDurationPerThrowPerEnemy',
			title: 'dashboard:dashboard|metrics|utility|tab|ratings|flash|duration',
			description: {
				Sniper: 'dashboard:dashboard|grenades|flash|duration|per|throw',
				Rifler: 'dashboard:dashboard|grenades|flash|duration|per|throw',
			},
			unit: 'common:common|sec',
			borderColor: '#846194',
			backgroundColor: 'rgb(132, 97, 148, 0.1)',
			analyticsEventName: 'FlashDurationPerThrowPerEnemy',
		},
		{
			order: 4,
			id: 'GrenadeDamagePer30Rounds',
			contentType: 'simple',
			rankId: 'UtilityDamagePer30Rounds',
			title: 'dashboard:dashboard|metrics|utility|tab|ratings|grenades|damage',
			description: {
				Sniper: 'dashboard:dashboard|grenades|he|damage|per|match',
				Rifler: 'dashboard:dashboard|grenades|he|damage|per|match',
			},
			unit: '',
			borderColor: '#846194',
			backgroundColor: 'rgb(132, 97, 148, 0.1)',
			analyticsEventName: 'UtilityDamagePerMatch',
		},
		{
			order: 5,
			id: 'EnemiesDamagedWithHEPer30Rounds',
			contentType: 'simple',
			rankId: 'EnemiesDamagedWithHEPer30Rounds',
			title: 'dashboard:dashboard|metrics|utility|tab|ratings|enemies|damaged',
			description: {
				Sniper: 'dashboard:dashboard|grenades|enemies|damaged|damaged|he',
				Rifler: 'dashboard:dashboard|grenades|enemies|damaged|damaged|he',
			},
			unit: '',
			borderColor: '#846194',
			backgroundColor: 'rgb(132, 97, 148, 0.1)',
			analyticsEventName: 'EnemiesDamagedWithHEPerMatch',
		},
	],
	grenades: [
		{
			title: 'common:tips|nade|flash|title',
			color: '#C0D5E3',
			titleGood: 'FlashGood',
			isGood: 0,
			description: 'common:tips|nade|flash|desc',
			texts: {
				good: 'common:tips|nade|flash|good',
				bad: 'common:tips|nade|flash|bad',
			},
			rows: [
				{
					id: 'FlashDurationPT',
					title: 'dashboard:dashboard|grenade|flash|duration',
					description: 'dashboard:dashboard|grenade|per|throw',
					countUnit: 'common:common|sec',
				},
				{
					id: 'EnemiesFlashedPT',
					title: 'dashboard:dashboard|grenade|flash|enemies',
					description: 'dashboard:dashboard|grenade|per|throw',
				},
				{
					id: 'FlashAssistsPT',
					title: 'dashboard:dashboard|grenade|flash|assist',
					description: 'dashboard:dashboard|grenade|per|throw',
				},
			],
		},
		{
			title: 'common:tips|nade|he|title',
			titleGood: 'HEGood',
			color: '#846194',
			isGood: 0,
			description: 'common:tips|nade|he|desc',
			texts: {
				good: 'common:tips|nade|he|good',
				bad: 'common:tips|nade|he|bad',
			},
			rows: [
				{
					id: 'HEDamagePT',
					title: 'dashboard:dashboard|grenade|he|damage',
					description: 'dashboard:dashboard|grenade|per|throw',
				},
				{
					id: 'HEDamagedPlayersPT',
					title: 'dashboard:dashboard|grenade|he|damage|players',
					description: 'dashboard:dashboard|grenade|per|throw',
				},
				{
					id: 'HEKillsPT',
					title: 'dashboard:dashboard|grenade|he|damage|kills',
					description: 'dashboard:dashboard|grenade|per|throw',
				},
			],
		},
		{
			title: 'common:tips|nade|molotov|title',
			titleGood: 'FireGood',
			color: '#DA745D',
			isGood: 0,
			description: 'common:tips|nade|molotov|desc',
			texts: {
				good: 'common:tips|nade|molotov|good',
				bad: 'common:tips|nade|molotov|bad',
			},
			rows: [
				{
					id: 'FireDamagePT',
					title: 'dashboard:dashboard|grenade|molotov|damage',
					description: 'dashboard:dashboard|grenade|per|throw',
				},
				{
					id: 'FireDamagedPlayersPT',
					title: 'dashboard:dashboard|grenade|molotov|damage|players',
					description: 'dashboard:dashboard|grenade|per|throw',
				},
			],
		},
	],
	mistakes: [
		{
			id: 'TeamFlashAssists',
			type: 1,
			title: 'common:tips|mistakes|team|flash|title',
			tooltipContent: 'common:tips|mistakes|team|flash|tooltip',
			tips: {
				good: 'common:tips|mistakes|team|flash|good',
				bad: 'common:tips|mistakes|team|flash|bad',
			},
			data: [],
		},
		{
			id: 'DiedFromSelfFlash',
			type: 1,
			title: 'common:tips|mistakes|died|from|self|title',
			tooltipContent: '',
			tips: {
				good: 'common:tips|mistakes|died|from|self|good',
				bad: 'common:tips|mistakes|died|from|self|bad',
			},
			data: [],
		},
		{
			id: 'DiedFromFall',
			type: 0,
			title: 'common:tips|mistakes|died|from|fall|title',
			tooltipContent: '',
			tips: {
				good: 'common:tips|mistakes|died|from|fall|good',
				bad: 'common:tips|mistakes|died|from|fall|bad',
			},
			data: [],
		},
		/* {
  	id: 'DryPeeks',
  	type: 0,
  	title: 'Dry Peeks',
  	tooltipContent: '',
  	tips: {
  		bad: 'Who could expect pushing a site without nades is a bad idea? In one of your recent games, you have peeked without being covered with grenades. You might have won a particular round or duel, but it’s always better to use nades before peeking. Check it out here on how to push properly.',
  		good: 'Absolutely destroying! All of your peeks were covered with grenades. You are amazing!'
  	},
  	data: [],
  }, */
		{
			id: 'TeamKills',
			type: 0,
			title: 'common:tips|mistakes|team|kills|title',
			tooltipContent: '',
			tips: {
				good: 'common:tips|mistakes|team|kills|good',
				bad: 'common:tips|mistakes|team|kills|bad',
			},
			data: [],
		},
		{
			id: 'DiedWithGrenadeInHand',
			type: 1,
			title: 'common:tips|mistakes|died|with|nade|title',
			tooltipContent: '',
			tips: {
				good: 'common:tips|mistakes|died|with|nade|good',
				bad: 'common:tips|mistakes|died|with|nade|bad',
			},
			data: [],
		},
		{
			id: 'FireExplodedInAir',
			type: 1,
			title: 'common:tips|mistakes|fire|exploded|air|title',
			tooltipContent: '',
			tips: {
				good: 'common:tips|mistakes|fire|exploded|air|good',
				bad: 'common:tips|mistakes|fire|exploded|air|bad',
			},
			data: [],
		},
		{
			id: 'FireLandedInSmoke',
			type: 1,
			title: 'common:tips|mistakes|fire|landed|smoke|title',
			tooltipContent: '',
			tips: {
				good: 'common:tips|mistakes|fire|landed|smoke|good',
				bad: 'common:tips|mistakes|fire|landed|smoke|bad',
			},
			data: [],
		},
		{
			id: 'SouldHaveBetterWeapon',
			type: 2,
			title: 'common:tips|mistakes|should|have|better|title',
			tooltipContent: '',
			tips: {
				good: 'common:tips|mistakes|should|have|better|good',
				bad: 'common:tips|mistakes|should|have|better|bad',
			},
			data: [],
		},
		{
			id: 'ShouldNotHaveBought',
			type: 2,
			title: 'common:tips|mistakes|should|not|bought|title',
			tooltipContent: '',
			tips: {
				good: 'common:tips|mistakes|should|not|bought|good',
				bad: 'common:tips|mistakes|should|not|bought|bad',
			},
			data: [],
		},
		{
			id: 'UnnecessaryArmor',
			type: 2,
			title: 'common:tips|mistakes|unnecessary|armor|title',
			tooltipContent: '',
			tips: {
				good: 'common:tips|mistakes|unnecessary|armor|good',
				bad: 'common:tips|mistakes|unnecessary|armor|bad',
			},
			data: [],
		},
		{
			id: 'ShouldHaveDropped',
			type: 2,
			title: 'common:tips|mistakes|should|have|dropped|title',
			tooltipContent: '',
			tips: {
				good: 'common:tips|mistakes|should|have|dropped|good',
				bad: 'common:tips|mistakes|should|have|dropped|bad',
			},
			data: [],
		},
		{
			id: 'ShouldHaveBoughtArmor',
			type: 2,
			title: 'common:tips|mistakes|should|have|bought|armor|title',
			tooltipContent: '',
			tips: {
				good: 'common:tips|mistakes|should|have|bought|armor|good',
				bad: 'common:tips|mistakes|should|have|bought|armor|bad',
			},
			data: [],
		},
	],
};

export default dashboardDefaultStates;
